module.exports = __webpack_public_path__ + "img/yourStyle-title.8f4b19e9.jpg";